import { Tabs, Tab } from "@mui/material";
import React from "react";
import { SUMMARY_TITLE_FONT } from "../../constants/Styles";

const tabsStyle = {
  minHeight: 36,
  "& .MuiTabs-indicator": {
    display: "none"
  },
  "& .MuiTabs-flexContainer": {
    gap: "10px"
  }
};

const tabStyle = {
  ...SUMMARY_TITLE_FONT,
  textTransform: "none",
  fontSize: 14,
  fontWeight: 500,
  minHeight: 36,
  minWidth: "auto",
  padding: "6px 18px",
  borderRadius: "999px",
  backgroundColor: "#f4f6f8",
  color: "#000",
  cursor: "pointer",
  transition: "all 0.18s ease",
};

const hoverTabStyle = {
  backgroundColor: "#eef2f5",
  transform: "translateY(-1px)",
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
};

const selectedTabStyle = {
  backgroundColor: "#10aa00",
  color: "#FFF",
  transform: "translateY(-1px)",
  boxShadow: "0 3px 8px rgba(0,0,0,0.12)"
};

export const StyledTabs = ({ children, ...props }) => (
  <Tabs {...props} sx={tabsStyle}>
    {children}
  </Tabs>
);

export const StyledTab = ({ selected, ...props }) => {
  const [hover, setHover] = React.useState(false);

  return (
    <Tab
      disableRipple
      {...props}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        ...tabStyle,
        ...(hover && !selected ? hoverTabStyle : {}),
        ...(selected ? selectedTabStyle : {})
      }}
    />
  );
};